import { gql } from '@apollo/client';

export const GET_CHECKHOMEWORK_OPTIONS = gql`
  query SkWeb_CheckHomeworkOptions($classroomId: ID!) {
    checkHomeworkOptions(classroomId: $classroomId) {
      products {
        id
        name
        payable
        level
        titles {
          id
          title
          booksets {
            id
            isHidden
            _title
            title
            level
          }
        }
      }
    }
  }
`;
